import { TableCell, TableRow } from '@hivewatch/dark'

import { WorkflowsColumnIProps, WorkflowsRowDataType } from '../types/types'

interface WorkflowsTableRowIProps {
  columns: WorkflowsColumnIProps[]
  row: WorkflowsRowDataType
  onClick?: () => void
}

export const WorkflowsTableRow = ({
  columns,
  row,
  onClick,
}: WorkflowsTableRowIProps) => {
  return (
    <TableRow onClick={onClick}>
      {columns.map((col) => (
        <TableCell key={col.key} {...col.style}>
          {col.cell(row)}
        </TableCell>
      ))}
    </TableRow>
  )
}
